import { render, staticRenderFns } from "./PaginaModelloC.vue?vue&type=template&id=3b3ecf96"
import script from "./PaginaModelloC.vue?vue&type=script&lang=js"
export * from "./PaginaModelloC.vue?vue&type=script&lang=js"
import style0 from "./PaginaModelloC.vue?vue&type=style&index=0&id=3b3ecf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports